module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/proveedor/proveedor.component.scss
// module id = ./src/app/productos/proveedor/proveedor.component.scss
// module chunks = main